export const CONTACTTYPE_DELETE_RESET = 'CONTACTTYPE_DELETE_RESET'
export const CONTACTTYPE_DELETE_SET_ERROR = 'CONTACTTYPE_DELETE_SET_ERROR'
export const CONTACTTYPE_DELETE_SET_DELETED = 'CONTACTTYPE_DELETE_SET_DELETED'
export const CONTACTTYPE_DELETE_TOGGLE_LOADING = 'CONTACTTYPE_DELETE_TOGGLE_LOADING'
